// Permission catalog. KEY = readable perm name, used in route `meta.perms`
// and `hasPerm()`; VALUE = backend `/account/user-perms` wire code, which is
// what `perms` actually contains (hasPerm translates key → code). Do NOT
// rename keys or values: the catalog is the contract between routing, UI
// checks, and account permission payloads.

export const PERMS_VALUE = {
  'allObj@allAct': '00',
  'cluster@all': '10',
  'cluster@view': '11',
  'cluster@create': '12',
  'cluster@edit': '13',
  'cluster@release': '14',
  'cluster@switch': '15',
  'cloudSettings@all': '20',
  'cloudSettings@view': '21',
  'cloudSettings@create': '22',
  'cloudSettings@edit': '23',
  'cloudSettings@release': '24',
  'member@all': '30',
  'member@view': '31',
  'member@create': '32',
  'member@edit': '33',
  'member@release': '34',
  'role@all': '40',
  'role@view': '41',
  'role@create': '42',
  'role@edit': '43',
  'role@release': '44',
  'billing@all': '50',
  'billing@view': '51',
  'billing@create': '52',
  'billing@edit': '53',
  'billing@release': '54',
  'alert@all': '60',
  'alert@view': '61',
  'alert@create': '62',
  'alert@edit': '63',
  'alert@release': '64',
  'org@all': '70',
  'org@view': '71',
  'org@create': '72',
  'org@modify': '73',
  'org@delete': '74',
  'payment@all': '80',
  'payment@view': '81',
  'payment@create': '82',
  'payment@modify': '83',
  'payment@delete': '84',
  'support@all': '90',
  'support@view': '91',
  'support@create': '92',
  'support@assign': '93',
} as const;

export type PermsKey = keyof typeof PERMS_VALUE;
